import {ROOT_URL} from '../../config';
import request, {uploadImage} from '../../components/api/api';
import {toastr} from 'react-redux-toastr';
import {push} from 'react-router-redux';
import {
    createdStaff,
    fetchedStaffMember,
    updatedStaff,
    disabledStaff,
    enabledStaff,
    deletedStaff,
    fetchedStaffTitles,
    fetchedJobTitles,
    fetchedStaffSites,
    fetchedStaffTeams,
    fetchedProjectsByDestination,
    fetchedStaffTranslations,
    fetchedStaffTranslation,
    updatedStaffTranslation,
    createdStaffTranslation,
    deletedStaffTranslation,
} from './actions';
import {getArrays} from '../../components/helpers/helpers';

export function fetchJobTitles() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/jobs`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedJobTitles(response.data))
        );
    };
}

export function fetchStaffSites() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/sites?_all=true`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedStaffSites(response.data))
        );
    };
}

export function fetchStaffTitles() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/staff-titles`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedStaffTitles(response.data))
        );
    };
}

export function createStaff(staff) {
    return (dispatch) => {
        let staffItemsToAdd = {};
        let prefix = 'staff';
        let staffSiteId = staff.site_id ? staff.site_id : 0;

        staffItemsToAdd['title'] = staff.title_name;
        staffItemsToAdd['firstname'] = staff.firstname;
        staffItemsToAdd['name'] = staff.name;
        staffItemsToAdd['description'] = staff.description;
        staffItemsToAdd['title_id'] = staff.title_id;
        staffItemsToAdd['site_id'] = staffSiteId;

        uploadImage(
            dispatch,
            {image: staff.image ? staff.image : null},
            prefix,
            staffSiteId,
            (response) => {
                let code = null;

                if (
                    response.data !== undefined &&
                    response.data.code !== undefined
                ) {
                    if (response.data.code.length) {
                        code = response.data.code;
                    }
                }

                staffItemsToAdd['code'] = code;

                Object.entries(staff).forEach(([key, dataArray]) => {
                    if (key === 'image') {
                        let newImage = {};
                        if (dataArray) {
                            newImage = {
                                alt: dataArray.alt,
                                title: dataArray.title,
                                filename: dataArray.filename,
                                description: dataArray.description,
                                link: dataArray.link,
                            };
                        }

                        return (staffItemsToAdd[key] = newImage);
                    }

                    if (key === 'products') {
                        let productsDataArray = [];

                        dataArray.map((data) => {
                            return productsDataArray.push({
                                destination_id: data.destination_id,
                                projects: data.projects,
                            });
                        });

                        return (staffItemsToAdd[key] = productsDataArray);
                    }

                    if (typeof dataArray === 'object') {
                        if (key !== 'products' && key !== 'image') {
                            staffItemsToAdd[key] = getArrays(dataArray);
                        }
                    }
                });

                let options = {
                    url: `${ROOT_URL}/staff`,
                    method: 'POST',
                    data: staffItemsToAdd,
                };

                return request(options, dispatch)
                    .then((response) => dispatch(createdStaff(response.data)))
                    .then(() =>
                        toastr.success(
                            'Success!',
                            'The staff member has been created.'
                        )
                    )
                    .then(() => dispatch(push(`/staff`)));
            }
        );
    };
}

export function updateStaff(staff) {
    return (dispatch) => {
        let staffItemsToUpdate = {};
        let prefix = 'staff';
        let staffSiteId = staff.site_id ? staff.site_id : 0;

        staffItemsToUpdate['title'] = staff.title_name;
        staffItemsToUpdate['firstname'] = staff.firstname;
        staffItemsToUpdate['name'] = staff.name;
        staffItemsToUpdate['description'] = staff.description;
        staffItemsToUpdate['title_id'] = staff.title_id;
        staffItemsToUpdate['site_id'] = staffSiteId;

        uploadImage(
            dispatch,
            {image: staff.image ? staff.image : null},
            prefix,
            staffSiteId,
            (response) => {
                let code = null;

                if (
                    response.data !== undefined &&
                    response.data.code !== undefined
                ) {
                    if (response.data.code.length) {
                        code = response.data.code;
                    }
                }

                staffItemsToUpdate['code'] = code;

                Object.entries(staff).forEach(([key, dataArray]) => {
                    if (key === 'image') {
                        let newImage = {};
                        if (dataArray) {
                            newImage = {
                                alt: dataArray.alt,
                                title: dataArray.title,
                                filename: dataArray.filename,
                                description: dataArray.description,
                                link: dataArray.link,
                                deleted: dataArray.deleted,
                            };
                        }

                        return (staffItemsToUpdate[key] = newImage);
                    }

                    if (key === 'products') {
                        let productsDataArray = [];

                        dataArray.map((data) => {
                            return productsDataArray.push({
                                destination_id: data.destination_id,
                                projects: data.projects,
                            });
                        });

                        return (staffItemsToUpdate[key] = productsDataArray);
                    }

                    if (
                        key !== 'products' &&
                        key !== 'image' &&
                        typeof dataArray === 'object'
                    ) {
                        staffItemsToUpdate[key] = getArrays(dataArray);
                    }
                });

                let options = {
                    url: `${ROOT_URL}/staff/${staff.id}`,
                    method: 'PUT',
                    data: staffItemsToUpdate,
                };
                return request(options, dispatch)
                    .then((response) => dispatch(updatedStaff(staff)))
                    .then((response) => dispatch(fetchStaffMember(staff.id)))
                    .then(() =>
                        toastr.success(
                            'Success!',
                            'The staff member has been updated.'
                        )
                    );
            }
        );
    };
}

export function deleteStaff(staffMember) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/staff/${staffMember}`,
            method: 'DELETE',
        };
        return request(options, dispatch)
            .then((response) => dispatch(deletedStaff(staffMember)))
            .then(() =>
                toastr.success(
                    'Success!',
                    'Staff ' + staffMember + ' has been deleted.'
                )
            );
    };
}

export function disableStaff(id) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/staff/${id}/deactivate`,
            method: 'PUT',
        };
        return request(options, dispatch)
            .then((response) => dispatch(disabledStaff(id)))
            .then(() =>
                toastr.success(
                    'Success!',
                    'Staff member with id ' + id + ' has been disabled.'
                )
            );
    };
}

export function enableStaff(id) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/staff/${id}/activate`,
            method: 'PUT',
        };
        return request(options, dispatch)
            .then((response) => dispatch(enabledStaff(id)))
            .then(() =>
                toastr.success(
                    'Success!',
                    'Staff member with id ' + id + ' has been enabled.'
                )
            );
    };
}

export function fetchStaffMember(id) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/staff/${id}`,
            method: 'GET',
        };

        return request(options, dispatch).then((response) =>
            dispatch(fetchedStaffMember(response.data))
        );
    };
}

export function fetchStaffTeams() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/staff-teams`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedStaffTeams(response.data))
        );
    };
}

export function fetchProjectsByDestination(destinationId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/projects-destinations?destinationId=${destinationId}`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedProjectsByDestination(response.data, destinationId))
        );
    };
}

export function fetchStaffTranslations(staffId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/staff/${staffId}/translations?_limit=100`,
            method: 'GET',
        };

        return request(options, dispatch).then((response) =>
            dispatch(fetchedStaffTranslations(response.data))
        );
    };
}

export function fetchStaffTranslation(staffId, translationId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/staff/${staffId}/translations/${translationId}`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedStaffTranslation(response.data))
        );
    };
}

export function createStaffTranslation(translation, staffId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/staff/${staffId}/translations`,
            method: 'POST',
            data: translation,
        };

        return request(options, dispatch)
            .then((response) => dispatch(createdStaffTranslation(translation)))
            .then(() =>
                toastr.success(
                    'Success!',
                    'The translation has been successfully created!'
                )
            )
            .then(() => dispatch(push(`/staff/${staffId}/translations`)));
    };
}

export function updateStaffTranslation(translation, staffId, translationId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/staff/${staffId}/translations/${translationId}`,
            method: 'PUT',
            data: translation,
        };

        return request(options, dispatch)
            .then((response) => dispatch(updatedStaffTranslation(translation)))
            .then(() =>
                toastr.success(
                    'Success!',
                    'The translation has been successfully updated!'
                )
            );
    };
}

export function deleteStaffTranslation(staffId, translationId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/staff/${staffId}/translations/${translationId}`,
            method: 'DELETE',
        };
        return request(options, dispatch)
            .then((response) =>
                dispatch(deletedStaffTranslation(translationId))
            )
            .then(() =>
                toastr.success(
                    'Success!',
                    'Translation with ID ' +
                        translationId +
                        ' has been deleted.'
                )
            );
    };
}



// WEBPACK FOOTER //
// ./src/containers/staff/thunks.js